import {
	GET_HOSPITALS_BASED_ON_REGION,
	GET_HOSPITALS_BASED_ON_REGION_SUCCESS,
	GET_HOSPITALS_BASED_ON_REGION_FAIL,
	GET_HOSPITALS_BASED_ON_REGION_RESET,
} from '../actions/getHospitalsBasedOnRegionAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getHospitalsBasedOnRegionReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_HOSPITALS_BASED_ON_REGION:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_HOSPITALS_BASED_ON_REGION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_HOSPITALS_BASED_ON_REGION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_HOSPITALS_BASED_ON_REGION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getHospitalsBasedOnRegionReducer;
